import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { LanguageModel } from '../models/language.model';

export class LanguagesApiService extends ApiService {
  static endpoint = 'languages';

  /**
   * @param {Number|null} languageId
   * @return {String}
   * @protected
   */
  static buildLanguageUrl(languageId = null) {
    return this.buildUrl(languageId);
  }

  /**
   * @param {String|Number} languageId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<LanguageModel>>}
   * @public
   */
  static async get(languageId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildLanguageUrl(languageId), {
      ...config,
      dataModel: LanguageModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} languageId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<LanguageModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildLanguageUrl(), {
      ...config,
      dataModel: LanguageModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<LanguageModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildLanguageUrl(), data, {
      ...config,
      dataModel: LanguageModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} languageId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<LanguageModel>>}
   * @public
   */
  static async patch(languageId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildLanguageUrl(languageId), data, {
      ...config,
      dataModel: LanguageModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} languageId
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(languageId, config = {}) {
    return HttpApiClient.delete(this.buildLanguageUrl(languageId), { ...config });
  }
}
